<template>
    <div class="content">
        <el-button type="primary" style="background-color: #2FBC82;" class="el-icon-plus" @click="Add"> 新增</el-button>
        <el-card style="margin-top:10px;width:100%;height: 100px;display: flex;flex-direction: column;justify-content: center;" class="box-card">
            <div style="display: flex;align-items: center;">
                <!-- <div class="search">
                        <label>类型：</label>
                        <el-select v-model="searchForm.fc_type" style="width:150px">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option label="单次有效" :value="1"></el-option>
                            <el-option label="多次有效" :value="2"></el-option>
                        </el-select>
                </div> -->
                <div class="search">
                        <label style="width: 55px;">名称：</label>
                        <el-input v-model="searchForm.fc_name"></el-input>
                </div>
                <div class="search" style="margin-left: 25px">
                        <el-button type="primary" plain @click="Search">查询</el-button>
                </div>
            </div>
        </el-card> 
              
              <el-table :data='DataList' border style="width: 100%;font-size:13px;margin-top: 15px;" stripe :highlight-current-row='true'>
                <el-table-column align="center" prop="fc_name" label="名称"></el-table-column>
                <el-table-column align="center" prop="fc_type" label="优惠码类型">
                    <template slot-scope="scope">
                        {{scope.row.fc_type===1?'单次有效':'多次有效'}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="dr_name" label="优惠券"></el-table-column>
                <el-table-column align="center" label="生效日期">
                    <template slot-scope="scope">
                        {{FormateTime(scope.row.fc_begin_day,scope.row.fc_end_day,0)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="生效时间">
                    <template slot-scope="scope">
                        {{FormateTime(scope.row.fc_begin_time,scope.row.fc_end_time,1)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.fc_status?'success':'danger'">{{scope.row.fc_status?'正常':"停用"}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="二维码">
                    <template slot-scope="scope">
                        <div style="width: 100%;height: 100%;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                            <img src='../../../assets/image/erweima.png' style="cursor: pointer;height: 20px;width: 20px;" @click='qrcodeShow(scope.row)'/>
                        </div>
                        
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                       <div>
                          <el-link type="primary" @click="Edit(scope.row)">修改</el-link>
                          <el-link v-if="scope.row.fc_status" type="warning" @click="Stop(scope.row,0)">停用</el-link>
                          <el-link v-if="!scope.row.fc_status" type="danger" @click="Stop(scope.row,1)">启用</el-link>
                      </div>
                  </template>
                </el-table-column>
              </el-table>
    
    
    
              <el-dialog :title="title" :visible.sync="dialogVisible" :width='screenWidth<738?"50%":(screenWidth<1200?"40%":"30%")' :append-to-body='true'>
                <el-form :model="qrForm" ref="qrForm" label-width="100px" size='medium'>
                    <el-form-item label="固定码名称">
                        <el-input v-model="qrForm.fc_name"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="优惠码类型" >
                        <el-radio-group v-model="qrForm.fc_type">
                            <el-radio :label="1">单次有效</el-radio>
                            <el-radio :label="2">多次有效</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="关联优惠" prop="dr_id" >
                        <el-select v-model="qrForm.fc_dr_id" style="width:100%" :disabled="isEnabeld">
                            <el-option v-for="item in DisDataList" :label="item.dr_name" :value="item.md_dr_id" :key='item.md_dr_id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生效日期">
                        <el-date-picker v-model="qrForm.day" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%;" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="生效时段">
                        <el-time-picker is-range v-model="qrForm.time" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" style="width: 100%;" format="HH:mm:ss" value-format="HH:mm:ss"></el-time-picker>
                    </el-form-item>
                    <el-form-item label="二维码张数">
                        <el-radio-group v-if="qrForm.fc_type===2" v-model="num_type">
                            <el-radio :label="-1">不限制</el-radio>
                            <el-radio :label="0">自定义</el-radio>
                        </el-radio-group>
                        <div :style="{marginTop:(qrForm.fc_type===2&&num_type===0?'10px':'0px')}">
                            <el-input-number v-if='(num_type===0&&qrForm.fc_type===2)||qrForm.fc_type===1' v-model="qrForm.fc_limit_quantity" :min="1" ></el-input-number>
                        </div>
                       
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </span>
              </el-dialog>
    
    
              <el-dialog title="固定二维码" :visible.sync="qrcodeDialog" width='350px' :append-to-body='true'>
                  <span  ref="qrImageId" v-show="false">{{qrid}}</span>
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;background-color: #23A7D9;height: 350px;width: 300px;color: white;">
                    <span>{{qrTitle}}</span>
                    <h1>扫码领取停车优惠</h1>
                    <VueQr :text="url" :size="180" :callback="qrcode_data" :logoScale="0.2"  :qid="qrid"></VueQr>
                    <span style="margin-top: 10px;">缴费后请尽快离场避免<span style="color: red;">超时</span>计费</span>
                </div>
    
                <span slot="footer" class="dialog-footer">
                    <el-button @click="qrcodeDialog = false">取 消</el-button>
                    <el-button type="primary" @click="Download">下 载</el-button>
                </span>
              </el-dialog>
    
    </div>
</template>

<script>
    import util from '../../../util/util'
    import VueQr from 'vue-qr'
    import JSZip from 'jszip'
    import filesave from 'file-saver'
    import html2canvas from 'html2canvas'
    
    export default {
      data: function () {
        return {
            screenWidth:0,
            DisDataList:[],


            DataList:[],
            searchForm:{
                mc_id:0,
                fc_name:'',
                fc_type:0
            },
    
    
            dialogVisible:false,
            title:'',
            qrForm:{
                fc_id:0,
                fc_mc_id:0,//车场方0，其他商户>0
                fc_status:1,
                fc_name:'',
                fc_type:2,
                fc_dr_id:null,
                day:[],
                time:[],
                fc_limit_quantity:0,
                limit_len:10
            },
            num_type:-1,
    
    
            isEnabeld:true,
    
    
            qrcodeDialog:false,
            qrid:'0',
            qrTitle:'',
            url: '',
        }
      },
      computed:{
            FormateTime(){
                return function(time1,time2,type){
                    var time=''
                    var t1= util.FormateDate(time1,type)
                    var t2=util.FormateDate(time2,type)
                    time=t1+' 至 '+t2
                    return time
                }
            }
        },
      components: {
        VueQr
      },
      created () {
        this.screenWidth = document.body.clientWidth
        let user=util.JesToken()
        if(user.user_type===5){
            this.qrForm.fc_mc_id=0
            this.searchForm.mc_id=0
        }
        if(user.user_type===6){
            this.qrForm.fc_mc_id=user.user_mer_id
            this.searchForm.mc_id=user.user_mer_id
        }
        util.Get('merchant/getmerremainbalance?id='+ this.qrForm.fc_mc_id).then(res=>{
            console.log(res)
            if(res.list&&res.list.length>0){
                this.DisDataList=res.list
            }
            else{
                this.$message.error('商户未充值优惠券，请充值后配置固定码')
            }
        })
        this.GetDataList()
      },
      methods: {
        GetDataList(){
            util.Post('fixedcode/getfixedcodedatalist',this.searchForm).then(res=>{
                if(res.rpStatus===10000)
                    this.DataList=res.list
            })
        },
        Add(){
            this.dialogVisible=true
            this.title='新增固定二维码'
            this.dialogVisible=true
            this.qrForm.fc_id=0
            this.qrForm.fc_type=2
            this.qrForm.fc_name=''
            this.qrForm.fc_dr_id= this.DisDataList[0].md_dr_id
            this.qrForm.fc_status=true
            this.qrForm.day=[]
            this.qrForm.time=['00:00:00',"23:59:59"]
            this.qrForm.fc_limit_quantity=0
            this.isEnabeld=false
        },
        Search(){
            this.GetDataList()
        },
    
        Edit(row){
            this.dialogVisible=true
            this.title='修改固定二维码'
            this.qrForm=JSON.parse(JSON.stringify(row))
           
            this.isEnabeld=true
    
            this.$set(this.qrForm,'day',[row.fc_begin_day,row.fc_end_day])
            this.$set(this.qrForm,'time',[this.qrForm.fc_begin_time,this.qrForm.fc_end_time])
            
            this.num_type=-1
            if(this.qrForm.fc_limit_quantity>0){
                this.num_type=0
            }
        },
    
        submit(){
            if(this.qrForm.fc_dr_id===0){
                this.$message.error("请选择关联的优惠券") 
                return            
            }
           
            this.qrForm.fc_begint_day=''
            this.qrForm.fc_end_day=''
            if(!this.qrForm.day||this.qrForm.day.length===0){
                this.$message.error('生效日期禁止为空')
                return
            }
            if(!this.qrForm.time||this.qrForm.time.length===0){
                this.$message.error('生效时段禁止为空')
                return
            }
    
            if(this.qrForm.day&&this.qrForm.day.length>0){
                this.qrForm.fc_begint_day=this.qrForm.day[0]
                this.qrForm.fc_end_day=this.qrForm.day[1]
            }
            this.qrForm.fc_begin_time=''
            this.qrForm.fc_end_time=''
            if(this.qrForm.time&&this.qrForm.time.length>0){
                this.qrForm.fc_begin_time=this.qrForm.time[0]
                this.qrForm.fc_end_time=this.qrForm.time[1]
            }
            if(this.qrForm.fc_type===2&&this.num_type===-1){
                this.qrForm.fc_limit_quantity=-1
            } 
    
            util.Post('fixedcode/edit',this.qrForm).then(res=>{
                if(res.rpStatus===10000){
                    this.dialogVisible=false
                    this.GetDataList()
                }
            })
        },
    
    
        Stop(row,state){
            let b=false
            if(state===0){
                this.$confirm('此操作将永久删除该文件, 是否继续?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    this.UpdateStatus(row,0)
                })
            }else{
                this.UpdateStatus(row,1)
            }
           
            
    
        },
        UpdateStatus(row,state){
            this.qrForm.fc_status=state
            this.qrForm.fc_id=row.fc_id
            this.qrForm.fc_name=row.fc_name
            util.Post('fixedcode/updatestatus',this.qrForm).then(res=>{
                if(res.rpStatus===10000){
                    this.GetDataList()
                }
            })
        },
    
    
    
        qrcodeShow(row){
            this.qrTitle=row.dr_name
            this.qrid=row.fc_id.toString()
            this.url='https://pay.yundiankong.com/discount?code='+row.fc_code
            this.qrcodeDialog=true
        },
        qrcode_data(dataUrl, id){
            var arr = this.DataList.filter(a => a.fc_id === parseInt(id))
            if (arr.length > 0) {
                arr[0].imgUrl = dataUrl
            }
        },
    
    
    
    
    
    
        CreateImageHtml(fc_id,qrData){
            let html='<div id="'+fc_id+'" style="display: flex;flex-direction: column;justify-content: center;align-items: center;background-color: #23A7D9;height: 350px;width: 300px;color: white;">'
            html+='<span>'+this.qrTitle+'</span>'   
            html+='<h1>扫码领取停车优惠</h1>'   
            html+='<img src="'+qrData+'"  style="margin-top: 10px;display: inline-block;">'
            html+='<span style="margin-top: 10px;">缴费后请尽快离场避免<span style="color: red;">超时</span>计费</span>'             
            html+='</div>'
            return html
        },
        async CreateDom(row){
          let html= this.CreateImageHtml(row.fc_id,row.imgUrl)
    
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML =html
    
          // 隐藏该元素：设置 position: absolute 并移出可视区
          Object.assign(tempDiv.style, {
            position: 'absolute',
            top: '-9999px',
            left: '-9999px',
            width: 'fit-content',
            height: 'fit-content',
    
          });
          document.body.appendChild(tempDiv);
          await this.$nextTick()
          return tempDiv
              
        },
        async Download(){
            var zip = new JSZip()
    
    
            let id= this.$refs.qrImageId.innerHTML
            var arr = this.DataList.filter(a => a.fc_id === parseInt(id))
    
            let tempDiv= await this.CreateDom(arr[0])
            await html2canvas(tempDiv, {
                  //scale: 2, // 提高清晰度
                  useCORS: true, // 允许跨域图片
                  allowTaint: false,
                  scrollY: 0,   
                  backgroundColor: '#ffffff' // 设置背景色
            }).then(canvas=>{
                  const link = document.createElement('a');
                  let url= canvas.toDataURL('image/png');
                  let qrName=`${arr[0].fc_name}.png`
                  let imgData=url.split(',')[1];
                  zip.file(qrName, imgData, { base64: true });
            })
                // 清理：移除临时 DOM
            document.body.removeChild(tempDiv);
    
            zip.generateAsync({ type: 'blob' }).then(function (content) {
                    filesave.saveAs(content, '二维码.zip')
            });
    
    
    
        },
    
      }
    }
    </script>
    
    
    
<style scoped>
    .content{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
    }
        
    .search{
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 13px;
    }
        
    .search label{
          width: 40px;
          margin-left: 25px;
    }
        
    .el-link{
            margin-right: 10px;
            font-size: 12px;
    }
</style>